import Swiper, { A11y, Navigation, Pagination, Autoplay, EffectFade, Parallax } from 'swiper'

const body  = document.querySelector('body');
const home  = body.classList.contains('home');

if (home) {
    Swiper.use([ A11y, Navigation, Pagination, Autoplay, EffectFade, Parallax ]);

    var alu = document.querySelector('.alu .swiper-container--media');

    // ALU
    if (alu) {
        var nberSlides = document.querySelectorAll('.alu .swiper-container--media .swiper-slide').length; 
        var totalSlide = document.querySelector('.alu-pagination__item--total');
        var dataSlideAuto = document.querySelector('.alu .swiper-container--media').getAttribute('data-slide_auto');

        if (totalSlide) {
            totalSlide.innerHTML = nberSlides;
        }

        // Media (image or video) swiper
        var aluConfig = {
            slidesPerView: 1,
            centeredSlides: true,
            speed: 1000,
            loop: true,
            parallax: true,
            grabCursor : 'true',

            keyboard: {
                enabled: true,
            },

            // Pagination (bullet)
            pagination: {
                el: '.alu__pagination',
                type: 'bullets', // default
                clickable: true,
            },

            a11y: {
                enabled: true,
                prevSlideMessage: 'Diapositive précédente',
                nextSlideMessage: 'Diapositive suivante',
                slideLabelMessage: '{{index}} / {{slidesLength}}', // default
            },
        };


        if (dataSlideAuto === '1') {
            aluConfig.autoplay = {
                delay: 100000, // Big number so it doesn't interfere with the progress bar function animation
                disableOnInteraction: false,
            }
        }

        var aluMedia = new Swiper('.alu .swiper-container--media', aluConfig);



        // Link + title/description swiper
        var aluContent = new Swiper('.alu .swiper-container--content', {
            slidesPerView: 1,
            centeredSlides: true,
            speed: 1000,
            loop: true,
            grabCursor: false,
            allowTouchMove: false,
            parallax: true,
        
            keyboard: {
                enabled: true,
            },
        
            mousewheel: {
                forceToAxis: true,
                releaseOnEdges: true,
            },

            // Pagination (bullet)
            pagination: {
                el: '.alu__pagination',
                type: 'bullets', // default
                clickable: true,
            },

            a11y: {
                enabled: true,
                prevSlideMessage: 'Diapositive précédente',
                nextSlideMessage: 'Diapositive suivante',
                slideLabelMessage: '{{index}} / {{slidesLength}}', // default
            },
        });
    }

    // Agenda
    const eventsSlideshow = document.querySelector('.home-events .swiper-container') !== null;
                
    if (eventsSlideshow) {
        let eventsSlides = document.querySelectorAll('.home-events .swiper-container .swiper-slide').length;

        Swiper.use([ A11y, Navigation ]);

        let eventsConfig = {
            effect : 'slide',
            grabCursor : 'false',
            speed: 700,
            loop: false,

            fadeEffect: {
                crossFade: true
            },

            keyboard: {
                enabled: true,
            },

            mousewheel: {
                forceToAxis: true,
                releaseOnEdges : true,
            },

            navigation: {
                nextEl: `.home-events .swiper-button-next`,
                prevEl: `.home-events .swiper-button-prev`,
            },

            a11y: {
                enabled: true,
                prevSlideMessage: 'Diapositive précédente',
                nextSlideMessage: 'Diapositive suivante',
                slideLabelMessage: '{{index}} / {{slidesLength}}', // default
            },

            breakpoints: {
                1201: {
                    spaceBetween: 60,  
                    slidesPerView: 'auto',
                },
        
                961: {
                    spaceBetween: 50, 
                    slidesPerView: 'auto',
                },
                
                641: {
                    spaceBetween: 50,
                    slidesPerView: 'auto',
                },
        
                0: {
                    spaceBetween: 30,
                    slidesPerView: 'auto',
                }
            }
        }

        let swiperevents = new Swiper('.home-events .swiper-container', eventsConfig);

        if(window.innerWidth > 960) {
            function updateMargins() {
                let slides = document.querySelectorAll('.home-events .swiper-container .swiper-slide');
    
                slides.forEach(function (slide) {
                    slide.style.marginTop = '0px';
                });
    
                let activeIndex = swiperevents.activeIndex;
    
                if (activeIndex >= 0 && activeIndex < slides.length) {
                    slides[activeIndex].style.marginTop = '0px';
    
                    for (let i = 1; i <= slides.length - 1; i++) {
                        let nextIndex = (activeIndex + i) % slides.length;
                        slides[nextIndex].style.marginTop = (i % 2 === 1) ? '0px' : '42px';
                    }
                }
            }
    
            swiperevents.on('slideChange', updateMargins);
    
            updateMargins();
        }

        // Fonction pour vérifier la taille de l'écran et le nombre de eventsSlides

        const postsNavigationEvents = document.querySelector('.home-events__navigation');

        function checkScreenSizeEvents() {
            const screenSizeEvents = window.innerWidth;
            const eventsSlides = document.querySelectorAll('.home-events .swiper-container .swiper-slide').length;

            if (screenSizeEvents > 960 && eventsSlides <= 3) {
                postsNavigationEvents.classList.add('disable');
            } else if (screenSizeEvents > 640 && eventsSlides <= 2) {
                postsNavigationEvents.classList.add('disable');
            } else if (screenSizeEvents <= 640 && eventsSlides <= 1) {
                postsNavigationEvents.classList.add('disable');
            } else {
                postsNavigationEvents.classList.remove('disable');
            }
        }

        checkScreenSizeEvents();

        window.addEventListener('resize', checkScreenSizeEvents);
    }

    // Documents
    const documentsSlideshow = document.querySelector('.home-documents .swiper-container') !== null;
            
    if (documentsSlideshow) {
        let documentsSlides = document.querySelectorAll('.home-documents .swiper-container .swiper-slide').length;

        Swiper.use([ A11y, Navigation ]);

        let documentsConfig = {
            effect : 'slide',
            grabCursor : 'true',
            speed: 700,
            loop : false,

            fadeEffect: {
                crossFade: true
            },

            keyboard: {
                enabled: true,
            },

            mousewheel: {
                forceToAxis: true,
                releaseOnEdges : true, 
            },

            navigation: {
                nextEl: `.home-documents .swiper-button-next`,
                prevEl: `.home-documents .swiper-button-prev`,
            },

            a11y: {
                enabled: true,
                prevSlideMessage: 'Diapositive précédente',
                nextSlideMessage: 'Diapositive suivante',
                slideLabelMessage: '{{index}} / {{slidesLength}}', // default
            },

            breakpoints: {
                1201: {
                    spaceBetween: 40,  
                    slidesPerView: 3,
                },
        
                961: {
                    spaceBetween: 20, 
                    slidesPerView: 3,
                },
                
                641: {
                    spaceBetween: 20,
                    slidesPerView: 1,
                }, 
        
                0: {
                    spaceBetween: 20,
                    slidesPerView: 1,
                }
            }

        }

        let swiperDocuments = new Swiper('.home-documents .swiper-container', documentsConfig);

        // Fonction pour vérifier la taille de l'écran et le nombre de documentsSlides
        const postsNavigationDocuments = document.querySelector('.home-documents__navigation');

        function checkScreenSizeDocuments() {
            const screenSizeEvents = window.innerWidth;
            const documentsSlides = document.querySelectorAll('.home-documents .swiper-container .swiper-slide').length;

            if (screenSizeEvents > 960 && documentsSlides <= 3) {
                postsNavigationDocuments.classList.add('disable');
            } else if (screenSizeEvents > 960 && documentsSlides <= 1) {
                postsNavigationDocuments.classList.add('disable');
            } else {
                postsNavigationDocuments.classList.remove('disable');
            }
        }

        checkScreenSizeDocuments();

        window.addEventListener('resize', checkScreenSizeDocuments);
    }

    // Portraits
    const bloc = document.querySelector('.portraits__items');
    const wrapper = document.querySelector('.portraits__wrapper');
    const slides = document.querySelectorAll('.portraits__item');

    if (window.innerWidth <= 960) {
        bloc.classList.add('swiper-container');
        wrapper.classList.add('swiper-wrapper');
        slides.forEach(slide => {
            slide.classList.add('swiper-slide');
        });

        const portraitsContainer = document.querySelector('.portraits .swiper-container') !== null;
            
        if (portraitsContainer) {
            let portraitsSlides = document.querySelector('.portraits .swiper-container .swiper-slide').length;

            Swiper.use([ A11y, Navigation ]);

            let portraitsConfig = {
                effect : 'slide',
                grabCursor : 'false',
                speed: 700,
                loop: false,
                

                fadeEffect: {
                    crossFade: true
                },

                keyboard: {
                    enabled: true,
                },

                mousewheel: {
                    forceToAxis: true,
                    releaseOnEdges : true,
                },

                navigation: {
                    nextEl: `.portraits .swiper-button-next`,
                    prevEl: `.portraits .swiper-button-prev`,
                },

                a11y: {
                    enabled: true,
                    prevSlideMessage: 'Diapositive précédente',
                    nextSlideMessage: 'Diapositive suivante',
                    slideLabelMessage: '{{index}} / {{slidesLength}}', // default
                },

                breakpoints: {
                    641: {
                        spaceBetween: 65,
                        slidesPerView: 'auto',
                    },
            
                    0: {
                        spaceBetween: 40,
                        slidesPerView: 'auto',
                    }
                }
            }

            // if (window.innerWidth <= 640) {
            //     let swiperportraits = new Swiper('.portraits .swiper-container', portraitsConfig);

            //     function updateMarginsPortraits() {
            //         let slidesPortraits = document.querySelectorAll('.portraits .swiper-container .swiper-slide');

            //         slidesPortraits.forEach(function (slide) {
            //             slide.style.marginTop = '0px';
            //         });

            //         let activeIndex = swiperportraits.activeIndex;

            //         if (activeIndex >= 0 && activeIndex < slidesPortraits.length) {
            //             slidesPortraits[activeIndex].style.marginTop = '0px';

            //             for (let i = 1; i <= slidesPortraits.length - 1; i++) {
            //                 let nextIndex = (activeIndex + i) % slidesPortraits.length;
            //                 slidesPortraits[nextIndex].style.marginTop = (i % 2 === 1) ? '0px' : '50px';
            //             }
            //         }
            //     }

            //     swiperportraits.on('slideChange', updateMarginsPortraits);

            //     updateMarginsPortraits();

            // } else
            let swiperportraits = new Swiper('.portraits .swiper-container', portraitsConfig);
            
            //  if (window.innerWidth > 640) {
                

            //     function updateMarginsPortraits() {
            //         let slidesPortraits = document.querySelectorAll('.portraits .swiper-container .swiper-slide');

            //         slidesPortraits.forEach(function (slide) {
            //             slide.style.marginTop = '60px';
            //         });

            //         let activeIndex = swiperportraits.activeIndex;

            //         if (activeIndex >= 0 && activeIndex < slidesPortraits.length) {
            //             slidesPortraits[activeIndex].style.marginTop = '60px';

            //             for (let i = 1; i <= slidesPortraits.length - 1; i++) {
            //                 let nextIndex = (activeIndex + i) % slidesPortraits.length;
            //                 slidesPortraits[nextIndex].style.marginTop = (i % 2 === 1) ? '60px' : '0px';
            //             }
            //         }
            //     }

            //     swiperportraits.on('slideChange', updateMarginsPortraits);

            //     updateMarginsPortraits();
            // }
        }
    }
}